export const COMPACT_MAP_OPEN_PARAM = 'mapOpen'
export const COMPACT_MAP_OPEN_VALUE = 'true'

export type CompactMapRouteParams = {
    [COMPACT_MAP_OPEN_PARAM]?: typeof COMPACT_MAP_OPEN_VALUE
}
